import {
  IPaymentConnectorPostMessage,
  PaymentConnectorPostMessageType,
} from '~/interfaces/payment';

export const paymentConnectorMessage = (
  data: string,
  messageType: PaymentConnectorPostMessageType,
): IPaymentConnectorPostMessage => {
  return {
    message: JSON.stringify({
      type: messageType,
      value: data,
    }),
    targetOrigin: '*',
  };
};
export const paymentConnectorSubmitMessage =
  (): IPaymentConnectorPostMessage => {
    return paymentConnectorMessage(
      'true',
      PaymentConnectorPostMessageType.Submit,
    );
  };
